export default "__VITE_ASSET__906012c1__"